import { render, staticRenderFns } from "./IdentityDocumentListView.vue?vue&type=template&id=5f168f3a&scoped=true&"
import script from "./IdentityDocumentListView.vue?vue&type=script&lang=js&"
export * from "./IdentityDocumentListView.vue?vue&type=script&lang=js&"
import style0 from "./IdentityDocumentListView.vue?vue&type=style&index=0&id=5f168f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f168f3a",
  null
  
)

export default component.exports